// ** Redux Imports
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit'

// ** Third Party Components
import client from '../providers/apollo-client'

// ** Actions
import { Me, UpdateBookmark } from '@graphql/authentication'

export const getBookmarks = createAsyncThunk('layout/getBookmarks', async () => {
  const response = await client.query({query: Me})

  return {
    data: response.data.me.suggestions,
    bookmarks: response.data.me.bookmarks
  }
})

export const updateBookmarked = createAsyncThunk('layout/updateBookmarked', async payload => {
  const {id, is_bookmarked} = payload
  client.mutate({mutation: UpdateBookmark, variables: {input: {module_id: id, bookmarked: is_bookmarked}}, refetchQueries: ['Me']})
  return id
})

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    query: '',
    bookmarks: [],
    suggestions: []
  },
  reducers: {
    handleSearchQuery: (state, action) => {
      state.query = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getBookmarks.fulfilled, (state, action) => {
        state.suggestions = action.payload.data
        state.bookmarks = action.payload.bookmarks
      })
      .addCase(updateBookmarked.fulfilled, (state, action) => {
        let objectToUpdate
        
        // ** find & update object
        state.suggestions.find(item => {
          if (item.id === action.payload) {
            item.pivot.is_bookmarked = !item.pivot.is_bookmarked
            objectToUpdate = item
          }
        })

        // ** Get index to add or remove bookmark from array
        const bookmarkIndex = state.bookmarks.findIndex(x => x.id === action.payload)

        if (bookmarkIndex === -1) {
          state.bookmarks.push(objectToUpdate)
        } else {
          state.bookmarks.splice(bookmarkIndex, 1)
        }
      })
  }
})

export const { handleSearchQuery } = layoutSlice.actions

export default layoutSlice.reducer
